import ApiAuthenticationService from "../services/ApiAuthenticationService";
import {ApplicationsAccessEnum} from "@/services/Enum/ApplicationsAccessEnum";


//Cette fonction permet de verifier si l'utilisateur à les droits d'accès à cette "route"
export function SecureGuard(to, from, next){
    ApiAuthenticationService.checkAccess((res) => {
        if(res === true){
            let currentApplicationsAccess = ApiAuthenticationService.getCurrentUser().applicationsAccess;
            if (typeof currentApplicationsAccess === 'object') {
                currentApplicationsAccess = Object.values(currentApplicationsAccess);
            }
            if (!currentApplicationsAccess || currentApplicationsAccess.length === 0) {
                return next('/global_no_access');
            }
            if (to.fullPath.includes('challenges') && currentApplicationsAccess.includes(ApplicationsAccessEnum.APP_CONCOURS)) {
                return next();
            }
            if (to.fullPath.includes('resume') && currentApplicationsAccess.includes(ApplicationsAccessEnum.APP_RESUME)) {
                return next();
            }
            if (to.fullPath.includes('parcourir') && (currentApplicationsAccess.includes(ApplicationsAccessEnum.APP_PARCOURIR) || currentApplicationsAccess.includes(ApplicationsAccessEnum.APP_PARCOURIR_NATIONAL))) {
                return next();
            }
            if (to.fullPath.includes('commerciaux') && currentApplicationsAccess.includes(ApplicationsAccessEnum.APP_COMMERCIALS)) {
                return next();
            }
            if (to.fullPath.includes('export') && (currentApplicationsAccess.includes(ApplicationsAccessEnum.APP_EXPORT) || currentApplicationsAccess.includes(ApplicationsAccessEnum.APP_ADMIN_EXPORT))) {
                return next();
            }
            if (to.fullPath.includes('pro') && currentApplicationsAccess.includes(ApplicationsAccessEnum.APP_PRO_PERSONAL)) {
                return next();
            }

            return next('/no_access');
        }
        else{
            return next(process.env.VUE_APP_LOGIN_ROUTE);
        }
    });
}
